<template>
  <HomeLayout>
    <div class="home" v-if="loading">
      <ProgressPage />
    </div>
    <div v-if="!loading">
      <div class="Profile margin-at-mobile">
        <HerbalAdvice :plant="activeServiceFirstSubService" :allowed_plant_consultings="allowed_plant_consultings" />
      </div>
    </div>
  </HomeLayout>
</template>

<script>
import HomeLayout from "../layout/HomeLayout";
import {globalMixin} from "@/mixins/globalMixin";
import {mapMixin} from "@/mixins/mapMixin";
import Api from "@/common/api";
import ProgressPage from "../components/UI/ProgressPage.vue";
import HerbalAdvice from "../components/SoilConsulting/HerbalAdvice";

export default {
  name: "Advice",
  components: {
    HomeLayout,
    HerbalAdvice,
    ProgressPage
  },
  inject: ["$axios"],
  mixins: [globalMixin, mapMixin],
  data() {
    return {
      activeServiceFirstSubService: null,
      allowed_plant_consultings: null,
    }
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.homeData();
  },
  methods: {
    homeData() {
      let self = this;
      Api.getHomeApi({ self: this })
          .then((response) => {
            if (response.status === 200) {
              let data = response.data;
              this.loading = false;
              this.allowed_plant_consultings = data.latest_service.allowed_plant_consultings;
              this.activeServiceFirstSubService =
                  data.latest_service.sub_services[0];
            }
          })
          .catch((error) => {
            this.serviceLoading = false;
            this.loading = false;
            self.handleError(self, error);
          });
    },
  }
}
</script>

<style lang="scss">
@import "src/styles/modules/Meteorology/Meteorology";
</style>